<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="供应商名称：">
					<el-input clearable v-model="formInline.name" size="small" placeholder="请输入供应商名称" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="联系人：">
					<el-input clearable v-model="formInline.contactUser" size="small" placeholder="请输入联系人" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="联系电话：">
					<el-input clearable v-model="formInline.contactPhone" size="small" placeholder="请输入联系电话" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/supply/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
					<el-button v-if="$checkBtnPermission('/supply/index', 'reset')" size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
					<el-button v-if="$checkBtnPermission('/supply/index', 'create')" size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增</el-button>
					<my-column-filter v-if="$checkBtnPermission('/supply/index', 'myFilter')" :list-columns="listColumns" @hide-pop="getCheckBox"></my-column-filter>
				</el-form-item>
			</el-form>
			<STable :columns="columnsData" :data="listData" :loading="loading" @get-data="getListData" @handle-command="handleCommand" @row-click="handleRowClick"></STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
	</div>
</template>

<script>
import { getSupplyInfoPageList, deleteSupplyInfo } from "../../../api/baseDataApi.js";
import edit from "./edit";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "供应商列表"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			selectionList: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				name: "",
				contactUser: "",
				contactPhone: ""
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "name",
					label: "供应商名称",
					isKeep: true,
					minWidth: "120"
				},
				{
					prop: "contactUser",
					label: "联系人",
					minWidth: "100"
				},
				{
					prop: "contactPhone",
					label: "联系电话",
					minWidth: "120"
				},
				{
					prop: "address",
					label: "地址"
				},
				{
					prop: "creator",
					label: "创建人",
					minWidth: "120"
				},
				{
					prop: "createTime",
					label: "创建时间",
					minWidth: "120"
				},
				{
					prop: "editor",
					label: "维护人",
					minWidth: "120"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					minWidth: "120"
				},
				{
					operation: true,
					isKeep: true,
					label: "操作",
					btnGroup: [
						{
							icon: "el-icon-delete",
							name: "删除",
							type: "4",
							btnType: "danger"
						}
					]
				}
			]
		};
	},
	// 注册组件
	components: {
		edit
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		handleCommand(command) {
			// 1编辑
			switch (command.command) {
				case "4":
					this.deleteUser(command.rowData);
					break;
				default:
					console.log(command);
			}
		},

		// 单击行数据
		handleRowClick(row) {
			this.$refs.edit.editShow(row);
		},
		//显示编辑界面
		handleEdit(row) {
			this.$refs.edit.editShow(row);
		},
		// 删除
		deleteUser(row) {
			this.$confirm("确定要删除供应商【" + row.name + "】吗?", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				let parmter = {
					keyId: row.keyId
				};
				deleteSupplyInfo(parmter)
					.then((res) => {
						if (res.code === 1) {
							this.$message({
								type: "success",
								message: "已删除!"
							});
							this.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("删除失败，请稍后再试！");
					});
			});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			getSupplyInfoPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		}
	}
};
</script>

<style scoped>
::v-deep(.el-link--primary) {
	color: #1d4ed8;
}

::v-deep(.el-link--primary:hover) {
	color: #1e40af;
}
</style>
